import type { BatchTransitionProviderProps } from "./batch-transition.type";

import BatchTransition from "./batch-transition.component";
import { BatchTransitionContext } from "./batch-transition.context";
import { useBatchTransitionContextData } from "./batch-transition.hook";

const BatchTransitionProvider = (props: BatchTransitionProviderProps) => {
  const value = useBatchTransitionContextData(props);

  return (
    <BatchTransitionContext.Provider value={value}>
      <BatchTransition />
    </BatchTransitionContext.Provider>
  );
};

export default BatchTransitionProvider;
